<template>
  <VCardActions>
    <slot />
  </VCardActions>
</template>

<script setup lang="ts">
import { VCardActions } from 'vuetify/components/VCard';
</script>
